<h1 class="margin-bottom">{{ 'home.talkersPage.title' | translate }}</h1>
<div>
    <h3 class="cooper">{{ 'home.talkersPage.storyTitle' | translate }}</h3>
    <div class="margin-top">
        <strong class="text-primary">{{ 'home.talkersPage.q1' | translate }}</strong>
    </div>
    <div>{{ 'home.talkersPage.a1' | translate }}</div>
    <div class="margin-top">
        <strong class="text-primary">{{ 'home.talkersPage.q2' | translate }}</strong>
    </div>
    <div>{{ 'home.talkersPage.a2' | translate }}</div>
    <div class="margin-top">
        <strong class="text-secondary-100 cooper text-medium">{{ 'home.talkersPage.quote' | translate }}</strong>
    </div>
    <div class="margin-top">
        <strong class="text-primary">{{ 'home.talkersPage.q3' | translate }}</strong>
     </div>
    <div>{{ 'home.talkersPage.a3' | translate }}</div>

</div>

<div class="margin-top-xl">
    <h3 class="cooper">{{ 'home.talkersPage.opinionsTitle' | translate }}</h3>
    <div class="wrap row-gap margin-top-xl">
        <app-talker-testimonial-quote [class.half-width-desktop]="index < 4" [color]="testimonial.color" [content]="testimonial.content" [author]="testimonial.author" *ngFor="let testimonial of testimonials; let index = index" [bubblePosition]="index % 2 === 0 ? 'left' : 'right'" />
    </div>
</div>

<div class="margin-top-xl">
    <h3 class="cooper">{{ 'home.talkersPage.genesisTitle' | translate }}</h3>
    <div class="margin-top">{{ 'home.talkersPage.genesisBody' | translate }}</div>
    <div class="testimonial-videos-container margin-top-xl">
        <div class="video-wrapper ratio-container">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/fKfdAeip6hw" frameborder="0" allowfullscreen></iframe>
        </div>
        <div class="video-wrapper ratio-container">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/wH3-5xIQOjk" frameborder="0" allowfullscreen></iframe>
        </div>
        <div class="video-wrapper ratio-container">
            <iframe width="560" height="315"  src="https://www.youtube.com/embed/w6vKY7qE0Og" frameborder="0" allowfullscreen></iframe>
        </div>
    </div>
</div>
